import React, { useState, useEffect } from "react"
// import Locatedoctor from '../../component/Locatedoctor'
import Modaldoctor from '../../component/Modaldoctor'
import Doctorlist from '../../component/Doctorlist'
import { getDoctor, addDoctor, editDoctor } from '../../doctorapi'
import { CSVLink } from "react-csv";
// import { useHistory } from "react-router-dom"
import './dashbord.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from "react-toastify"
import { CsvButton } from "./styles";
import { CSV_HEADERS } from "../../constant";
var moment = require('moment');
// import { Button } from "reactstrap"

const Dashboard = ({ isedit, setisedit, modal, setModal, checkAlldata, setCheckAllData, getAllData, setGetAllData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [editvalue, seteditvalue] = useState()

  toast.configure()
  let changedDate
  const notify = msg => {
    if (msg == "error") {
      toast.error("Internal Server Error")
    } else if (msg == "success") {
      toast.success("Doctor Created Successfully")
    }
    else if (msg == "editsuccess") {
      toast.success("Doctor Updated Successfully")
    }
    else if (msg == "logoutsuccess") {
      toast.success("Logout Successfully")
    } else if (msg == "uniqueerror") {
      toast.error("Doctor Already Exist")
    }
  }
  const handleAddSubmit = (values) => {
      // return
    setIsLoading(true);
    addDoctor(values).then(response => {
      setIsLoading(false);
      if (response.data.statusCode == 200) {
        notify("success")
        let data = [...getAllData]
        data.unshift(response.data.body)
        setGetAllData(data)
        setModal(!modal)
      } else {
        // console.log("object",error)
      }
    }).catch(error => {
      setIsLoading(false);
      console.log("errorrrrrrrrr", error.message)
      if (error.message === "Request failed with status code 500") {
        notify("error")
      } else {
        notify("uniqueerror")
      }
      // setModal(!modal)
    })
  }
  const handleedit = (values) => {
    setisedit(true)
    seteditvalue(values.original)
  }

  const handleEditapi = (values) => {
    setIsLoading(true);
    editDoctor(values).then(response => {
      setIsLoading(false);
      if (response.data.statusCode == 200) {
        let data = getAllData.findIndex(
          item => item._id === response.data.body._id
        )
        if (data > -1) {
          let newdata = getAllData
          newdata.splice(data, 1, response.data.body)
          setGetAllData([...newdata])
          notify("editsuccess")
          setModal(!modal)
          setisedit(false)
        }
      } else {
      }
    }).catch(error => {
      setIsLoading(false);
      console.log("error", error)
      if (error.message === "Request failed with status code 500") {
        notify("error")
      } else {
        notify("uniqueerror")
        setisedit(false)
      }
      setModal(!modal)
    })
  }
  const toggle = (modal) => {
    isedit ? setisedit(false) : null
    setModal(!modal)
  };


  return (
    <div style={{ position: "relative" }}>
      <Modaldoctor handleAddSubmit={handleAddSubmit}
        toggle={toggle}
                   isLoading={isLoading}
        modal={modal}
        editvalue={editvalue}
        isedit={isedit}
        handleEditapi={handleEditapi} />


      <Doctorlist getAllData={getAllData}
        setGetAllData={setGetAllData}
        handleedit={handleedit}
        toggle={toggle}
      />
    </div>
  )
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js